import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { LEAK_THRESHOLD, leakSignals } from "../data/landing";
import { trackOnce } from "../utils/tracking";
import { CTAButton } from "./CTAButton";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
export function LeakChecklist() {
  const [checked, setChecked] = useState<Set<number>>(new Set());
  const reduce = useReducedMotion();
  const hasLeak = checked.size >= LEAK_THRESHOLD;
  useEffect(() => {
    if (hasLeak) trackOnce("LeakChecklist3Plus", {}, {
      custom: true
    });
  }, [hasLeak]);
  const toggle = (i: number) => setChecked(prev => {
    const next = new Set(prev);
    if (next.has(i)) next.delete(i);else next.add(i);
    return next;
  });
  return <section aria-labelledby="senales-fuga" className="section-pad border-b border-line" data-id="element-297" data-mp="154jvxbsckbmt">
      <div className="page-container" data-id="element-298" data-mp="156ej6wr3cfu2">
        <div className="max-w-3xl" data-id="element-299" data-mp="26gflzkpo3xdp">
          <Reveal data-id="element-300" data-mp="26fe7t7dcuurr">
            <SectionHeader number="07" label="Autodiagnóstico" titleId="senales-fuga" title="Señales de que tienes una fuga" data-id="element-301" data-mp="26dtbpdbe73rs" />
            <p className="body-copy mt-6" data-id="element-302" data-mp="1xhc068z493vi">Si marcas 3 o más, vale la pena revisarlo.</p>
          </Reveal>

          <Reveal className="-mx-6 mt-10 md:mx-0 md:mt-12" data-id="element-303" data-mp="1sir1wf3fcu9p">
            <ul className="border-y border-line md:rounded-[3px] md:border" data-id="element-304" data-mp="1niw7w2ocrokf">
              {leakSignals.map((text, i) => {
              const isChecked = checked.has(i);
              return <li key={text} className="border-b border-line last:border-b-0" data-id="element-305" data-mp="1ds1jarnmwcvt" data-mpi={i}>
                    <button type="button" role="checkbox" aria-checked={isChecked} onClick={() => toggle(i)} className={`flex min-h-[56px] w-full items-center gap-4 px-6 py-3 text-left text-[16px] transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold md:px-5 md:text-[17px] ${isChecked ? "bg-gold/[0.07] text-cream" : "text-cream/90 hover:bg-white/[0.04]"}`} data-id="element-306" data-mp="19qy8wkocv91z">
                      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-[3px] border transition-colors duration-200 ease-out ${isChecked ? "border-gold bg-gold" : "border-steel"}`} aria-hidden="true" data-id="element-307" data-mp="l5aa3qv8acl9">
                        {isChecked && <CheckIcon className="h-4 w-4 text-ink" strokeWidth={3} data-id="element-308" data-mp="1434hk0gpkg1j" />}
                      </span>
                      <span className="leading-snug" data-id="element-309" data-mp="1rsoxsblh8z74">{text}</span>
                    </button>
                  </li>;
            })}
            </ul>
          </Reveal>

          <AnimatePresence initial={false} data-id="element-310" data-mp="3h9u8pvmx3o52">
            {hasLeak && <motion.div key="leak-result" initial={reduce ? {
            opacity: 0
          } : {
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={reduce ? {
            opacity: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.25,
            ease: [0.22, 1, 0.36, 1]
          }} className="mt-8" aria-live="polite" data-id="element-311" data-mp="3cbsr7f553wvp">
                <p className="font-ui text-[18px] font-bold leading-snug text-gold" data-id="element-312" data-mp="2td6pby1su1qq">
                  Tienes señales claras de fuga.
                </p>
                <div className="mt-6" data-id="element-313" data-mp="37drav1z3mbnx">
                  <CTAButton source="leak" data-id="element-314" data-mp="33b2xqi3cqil5" />
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}